module.exports = __webpack_public_path__ + "img/standard.0142d277.jpg";